import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextField = _resolveComponent("TextField")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.width)
  }, [
    _createVNode(_component_TextField, {
      class: "flex",
      name: "searchbox",
      type: "string",
      placeholder: "Buscar",
      "icon-name": "magnify",
      compact: true,
      onInput: _ctx.handleSearch
    }, null, 8, ["onInput"])
  ], 2))
}